const Routes = {
    LOGIN: '/login',
    LOGOUT: '/logout',
    REGISTER: '/register',
    CONFIRM_EMAIL: '/confirm-email',
    FORGOT_PASSWORD: '/forgot-password',
    RESET_PASSWORD: '/reset-password',
    ACCOUNT_SETUP: '/account-setup',
    SNHU_ACTIVATION: '/snhu-activation',

    SETTINGS: '/settings',

    HOME: '/',
    ASSIGNMENTS: '/assignments',
    PROBLEM_SETS: '/problem-sets',
    CONCEPTUAL_LABELS: '/conceptual-labels',
    INSTANT_FEEDBACK: '/instant_feedback',
    TEXT_INSTANT_FEEDBACK: '/text_instant_feedback',
    ASSIGNMENT: '/assignments/:token/:layerId/*',
    ASSIGNMENT_BASE: '/assignments/:token/:layerId',
    ASSIGNMENT_FULL: '/assignments/:token/:layerId/:section',

    TERMS_OF_USE: '/terms-of-use',
    PRIVACY_POLICY: '/privacy-policy',
    ACCESSIBILITY: '/accessibility',

    CART: '/cart',
    CATALOG: '/catalog',
    CATALOG_ITEM: '/catalog/:id',
}

export default Routes
